define([
	"dojo/store/Memory",
	"./common",
	"csi/locale",
	"csi/prefs/_base",
], function(Memory, { DISABLED_PROPERTY }, locale,prefs) {

	var	all = {id: "0", name: "", value: 0};

	locale.deferred.then(function() {
		all.name = locale.resource("PAGE_ALL");
		all[DISABLED_PROPERTY] = !prefs.hasAdminAccess();
	});

	return new Memory({
		data: [
			{name: "20", id: "20", value: 20},
			{name: "50", id: "50", value: 50},
			{name: "100", id: "100", value: 100},
			{name: "200", id: "200", value: 200},
			all
		]
	});
});